<template>
  <section class="features-section" id="current-features">
    <div class="container">
      <h2>Current Features</h2>
      <div class="features-grid">
        <CardComponent
          v-for="(feature, index) in features"
          :key="index"
          :title="feature.title"
          :description="feature.description"
        />
      </div>
    </div>
  </section>
</template>

<script>
import CardComponent from "./CardComponent.vue";

export default {
  name: "FeaturesList",
  components: {
    CardComponent,
  },
  data() {
    return {
      features: [
        {
          title: "Advanced Encryption",
          description:
            "Utilizes state-of-the-art encryption algorithms to keep your passwords safe",
        },
        {
          title: "Layered Security",
          description: "Multi-layered encryption for depth of defense",
        },
        {
          title: "Local & Untracked",
          description:
            "No servers, no tracking, no cloud storage. Your data is yours alone — always",
        },
        {
          title: "Completely Offline",
          description:
            "Work offline without any dependency on third-party services. Privacy guaranteed",
        },
        {
          title: "User-Friendly Interface",
          description:
            "Intuitive design makes managing your passwords effortless",
        },
        {
          title: "One-Time Purchase",
          description:
            "No recurring fees or subscription models. Buy once and own it forever",
        },
      ],
    };
  },
};
</script>

<style scoped>
@import "@/styles/components/Features.scss";
</style>
